import {UseQueryResult} from "@tanstack/react-query";
import {Resource} from "../types/resource";
import {ResourceErrorType, ResourceException} from "../types/resourceError";
import {getResourceError} from "./resourceUtils";
import {Company} from "../types/domain/company";

/// Tanstack-Query version of page-specific error message, old one will be removed after refactoring
export const getResourcePageErrorMessageTSQ = (
    query: UseQueryResult<Company, ResourceException>,
): string | undefined => {
    if (!query.isError || !query.error) return undefined;

    const resourceError = query.error.resourceError;

    if (resourceError?.type === ResourceErrorType.HTTP_FORBIDDEN_ERROR) {
        return "You are not authorized to view the page";
    } else if (
        resourceError?.type === ResourceErrorType.HTTP_NOT_FOUND_ERROR ||
        resourceError?.type === ResourceErrorType.HTTP_BAD_REQUEST_ERROR
    ) {
        return "Not found";
    } else {
        return "Unknown error";
    }
};

/**
 * Returns page-specific error message, ie 404 Not Found, 403 Not Authorized
 */
export const getResourcePageErrorMessage = (resource: Resource<Promise<unknown>>): string | undefined => {
    const resourceError = getResourceError(resource);

    if (resourceError !== undefined) {
        if (resourceError.type === ResourceErrorType.HTTP_FORBIDDEN_ERROR) {
            return "You are not authorized to view the page";
        } else if (
            resourceError.type === ResourceErrorType.HTTP_NOT_FOUND_ERROR ||
            resourceError.type === ResourceErrorType.HTTP_BAD_REQUEST_ERROR
        ) {
            return "Not found";
        } else {
            return "Unknown error";
        }
    } else {
        return undefined;
    }
};
